import { render, staticRenderFns } from "./search-adverts-list-photos.vue?vue&type=template&id=45708683"
import script from "./search-adverts-list-photos.vue?vue&type=script&lang=ts"
export * from "./search-adverts-list-photos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports